import { createRoutine } from 'redux-saga-routines';
import { createAction } from 'redux-actions';
import { LIST_WAIT_LIST, SET_WAIT_LIST, LAST_UPDATE_WAIT_LIST } from './types';

export const listWaitList = createRoutine(LIST_WAIT_LIST);

export const lastUpdateWaitList = createAction(LAST_UPDATE_WAIT_LIST);
export const setWaitList = createAction(SET_WAIT_LIST);
